export const imageNames = {
  SUPER_AGI_LOGO: "superAgiLogo",
  DRAGGABLE_DOTS: "draggableDots",
  EMPTY_STATE_SECONDARY: "emptyStateSecondary",
  BOTTOM_ARROW: "bottomArrow",
  BOTTOM_ARROW_GREY: "bottomArrowGrey",
  RESEARCH_SELECTED: "researchSelected",
  RESEARCH_UNSELECTED: "researchUnselected",
  ANALYTICS_SELECTED: "analyticsSelected",
  BUSINESS_DETAILS_SELECTED: "businessDetailsSelected",
  BUSINESS_DETAILS_UNSELECTED: "businessDetailsUnselected",
  AI_SDR_SELECTED: "aiSDRSelected",
  AI_SDR_UNSELECTED: "aiSDRUnselected",
  GENERAL_SELECTED: "generalSelected",
  GENERAL_UNSELECTED: "generalUnselected",
  PROFILE_SELECTED: "profileSelected",
  PROFILE_UNSELECTED: "profileUnselected",
  EDIT_SQUARE: "editSquare",
  NUMBER_GREY: "numberGrey",
  BOOLEAN_GREY: "booleanGrey",
  PRODUCTS_SELECTED: "productsSelected",
  PRODUCTS_UNSELECTED: "productsUnselected",
  INVOICES_SELECTED: "invoicesSelected",
  INVOICES_UNSELECTED: "invoicesUnselected",
  INTEGRATIONS_SELECTED: "integrationsSelected",
  INTEGRATIONS_UNSELECTED: "integrationsUnselected",
  WATERFALL_SELECTED: "waterfallSelected",
  WATERFALL_UNSELECTED: "waterfallUnselected",
  EMAIL_TEMPLATES_SELECTED: "emailTemplateSelected",
  EMAIL_TEMPLATES_UNSELECTED: "emailTemplatesUnselected",
  CONVERSATIONS_GREY: "conversationsGrey",
  CONTENT_SELECTED: "contentSelected",
  USERS_SELECTED: "usersSelected",
  USERS_UNSELECTED: "usersUnselected",
  TASKS_SELECTED: "tasksSelected",
  TASKS_UNSELECTED: "tasksUnselected",
  FOLLOW_UP_TASK_DOUBLE_ARROW: "followUpTaskDoubleArrow",
  OUTPUT_SELECTED: "outputSelected",
  OUTPUT_UNSELECTED: "outputUnselected",
  BILLING_SELECTED: "billingSelected",
  BILLING_UNSELECTED: "billingUnselected",
  VOICEMAIL_SELECTED: "voicemailSelected",
  VOICEMAIL_UNSELECTED: "voicemailUnselected",
  VOICEMAIL_DROP_SELECTED: "voicemailDropSelected",
  VOICEMAIL_DROP_UNSELECTED: "voicemailDropUnselected",
  SEARCH_VARIANT1: "searchVariant1",
  ENRICH_SEARCH: "enrichSearch",
  ADS_CLICK: "adsClick",
  FILTER_GREY: "filterGrey",
  FILTER_ACTIVE: "filterActive",
  FILTER_SELECTED: "filterSelected",
  CHEVRON_ARROW_LEFT_GREY: "chevronArrowLeftGrey",
  CHEVRON_ARROW_RIGHT: "chevronArrowRight",
  DISCORD: "discord",
  ADD_BLACK: "addBlack",
  MORE_VERTICAL: "moreVertical",
  EDIT: "edit",
  CLONE_GREY: "cloneGrey",
  DELETE_GREY: "deleteGrey",
  CLOSE_GREY: "closeGrey",
  EMAIL_GREY: "emailGrey",
  CHANNEL_EMAIL: "channelEmail",
  CHANNEL_WHATSAPP: "channelWhatsapp",
  CONTACTS_LEADS: "contactsLeads",
  CALL_GREY: "callGrey",
  WHATSAPP_GREY: "whatsappGrey",
  WHATSAPP_SELECTED: "whatsappSelected",
  ACTION: "action",
  MEETING_GREY: "meetingGrey",
  NOTE: "note",
  TASK: "task",
  NEW_TASK_GREY: "newTaskGrey",
  LINKEDIN_SELECTED: "linkedinSelected",
  LINKEDIN_UNSELECTED: "linkedinUnSelected",
  MARK_AS_DONE: "markAsDone",
  MARKED_AS_DONE: "markedAsDone",
  LEFT_ARROW: "leftArrow",
  LEFT_ARROW_WHITE: "leftArrowWhite",
  LEFT_ARROW_GREY: "leftArrowGrey",
  RIGHT_ARROW: "rightArrow",
  EMPTY_SCREEN_GREY: "emptyScreenGreyDarkIcon",
  CHART_AND_TABLE_EMPTY_SCREEN_GREY: "chartAndTableEmptyScreenGreyDarkIcon",
  CALL_LOGS_EMPTY_SCREEN_GREY: "callLogsEmptyScreenGreyDarkIcon",
  CALL_QUALITY_EMPTY_SCREEN_GREY: "callQualityEmptyScreenGreyDarkIcon",
  CALL_CAMPAIGNS_EMPTY_SCREEN: "callCampaignsEmptyScreen",
  SUPER_AGI_EMPTY_BOLT: "superAGIEmptyBolt",
  APOLLO: "apollo",
  SENDSPARK: "sendspark",
  HORIZONTAL_THREE_DOTS: "horizontalThreeDots",
  HORIZONTAL_THREE_DOTS_GREY: "horizontalThreeDotsGrey",
  BACK_ARROW_DEFAULT_GREY: "backArrowDefaultGrey",
  BACK_ARROW_WHITE: "backArrowWhite",
  BACK_ARROW_VARIANT1_GREY: "backArrowVariant1Grey",
  PIPELINES_SELECTED: "pipelinesSelected",
  PIPELINES_UNSELECTED: "pipelinesUnselected",
  ENTITY_SCORING_SELECTED: "entityScoringSelected",
  ENTITY_SCORING_UNSELECTED: "entityScoringUnselected",
  REPLY: "reply",
  REPLY_ALL: "replyAll",
  FORWARD: "forward",
  SEND_WHITE: "sendWhite",
  SEND_BLACK: "sendBlack",
  SEARCH_EMPTY_SCREEN_GREY: "searchEmptyScreenGrey",
  SEARCH: "search",
  TABLE_VIEW_UNSELECTED: "tableViewUnselected",
  TABLE_VIEW_SELECTED: "tableViewSelected",
  KANBAN_VIEW_UNSELECTED: "kanbanViewUnselected",
  KANBAN_VIEW_SELECTED: "kanbanViewSelected",
  HIGH_PRIORITY: "highPriority",
  LOW_PRIORITY: "lowPriority",
  MEDIUM_PRIORITY: "mediumPriority",
  PLUS: "plus",
  REMOVE_GREY: "removeGrey",
  TICK_GREY: "tickGrey",
  TICK_WHITE: "tickWhite",
  BOLD_TICK_GREY: "boldTickGrey",
  MANUAL_GREY: "manualGrey",
  ADD: "add",
  OUTREACH: "outreach",
  COMPLETE_CAMPAIGN_STEP: "completeCampaignStep",
  PROGRESS_CAMPAIGN_STEP: "progressCampaignStep",
  REMAINING_CAMPAIGN_STEP: "remainingCampaignStep",
  PREVIEW_LEADS: "previewLeads",
  DUSTBIN_GREY: "dustbinGrey",
  EMAIL_STEP: "emailStep",
  QUESTION_MARK: "questionMark",
  AGI_MARK: "agiMark",
  AUTOMATION: "automation",
  ARROW_DOWN_TOOLTIP_GREY: "arrowDownTooltipGrey",
  AGI_PURPLE: "agiPurple",
  CALENDAR_EDIT_GREY: "calendarEditGrey",
  RIGHT_SELECTED_GREY: "rightSelectedGrey",
  CROSS_MARK: "crossMark",
  TICK_MARK: "tickMark",
  NO_TEMPLATE_GREY: "noTemplateGrey",
  MAIL_GREY: "mailGrey",
  CURLY_BRACE_GREY: "curlyBraceGrey",
  CURLY_BRACE_WITH_LIGHTNING_GREY: "curlyBraceWithLightningGrey",
  STACKED_EMAIL_GREY: "stackedEmailGrey",
  SETTINGS_GREY: "settingsGrey",
  TUNE: "tune",
  SETTINGS_ICON: "settingsIcon",
  LOGOUT_GREY: "logoutGrey",
  REFER_GREY: "referGrey",
  ADD_GREY: "addGrey",
  LINK: "link",
  SORTING_ARROW_GREY: "sortingArrowGrey",
  SORTING_ARROW_SELECTED: "sortingArrowSelected",
  EMOJI_GREY: "emojiGrey",
  IS_TYPING: "isTyping",
  INFO: "info",
  WARNING: "warning",
  ANNOUNCEMENT: "announcement",
  GMAIL_LOGO: "gmailLogo",
  NOTIFICATION: "notification",
  EMAIL_BLACK: "emailBlack",
  NO_NOTIFICATIONS_GREY: "noNotificationsGrey",
  MORE_VERTICAL_DISABLED: "moreVerticalDisabled",
  LINKEDIN_GREY: "linkedinGrey",
  SUITCASE_LIGHT: "suitcaseLight",
  SUITCASE_DARK: "suitcaseDark",
  LINKEDIN_STEP: "linkedinStep",
  SMS_GREY: "smsGrey",
  CONTENT_GREY: "contentGrey",
  COPY_GREY: "copyGrey",
  CHECK_BLACK: "checkBlack",
  ATTACH_FILE_GREY: "attachFileGrey",
  DOWNLOAD_GREY: "downloadGrey",
  PRINT_GREY: "printGrey",
  CAMPAIGN_TEMPLATES_UNSELECTED: "campaignTemplatesUnselected",
  CAMPAIGN_TEMPLATES_SELECTED: "campaignTemplatesSelected",
  CONVERSATIONS_BLANK_GREY: "conversationsBlankGrey",
  APP_STORE: "appStore",
  OUTLOOK_LOGO: "outlookLogo",
  CHECK: "check",
  SUPER_AGI_LOGO_ROUND: "superAGILogoRound",
  UPLOAD_GREY: "uploadGrey",
  CSV_FILE: "csvFile",
  PREVIEW: "preview",
  MAILBOXES_SELECTED: "mailboxesSelected",
  MAILBOXES_UNSELECTED: "mailboxesUnselected",
  REPLIES_SELECTED: "repliesSelected",
  REPLIES_UNSELECTED: "repliesUnselected",
  OVERVIEW_UNSELECTED: "overviewUnselected",
  GO_TO_LINK_GREY: "goToLinkGrey",
  TRACKING_DOMAIN_SELECTED: "trackingDomainSelected",
  TRACKING_DOMAIN_UNSELECTED: "trackingDomainUnselected",
  INFO_GREY: "infoGrey",
  PAUSE_GREY: "pauseGrey",
  PAUSE_VARIANT1_ICON: "pauseVariant1Icon",
  GREEN_DOT: "greenDot",
  ORANGE_DOT: "orangeDot",
  RED_DOT: "redDot",
  WHITE_DOT: "whiteDot",
  WARMUP: "warmup",
  RESUME_BLACK: "resumeBlack",
  RESUME_WHITE: "resumeWhite",
  RESUME_GREY: "resumeGrey",
  PLAY_ICON: "playIcon",
  PAUSE_ICON: "pauseIcon",
  CIRCLE_PLAY_ICON: "circlePlayIcon",
  CIRCLE_PAUSE_ICON: "circlePauseIcon",
  CHECK_GREEN: "checkGreen",
  ERROR: "error",
  WHATS_NEW: "whatsNew",
  CLOCK: "clock",
  RIGHT_ARROW_DEFAULT: "rightArrowDefault",
  WARNING_TRIANGLE: "warningTriangle",
  ACTIVITY: "activity",
  ANALYTICS: "analytics",
  OVERVIEW: "overview",
  DEALS_GREY: "dealsGrey",
  LEADS_GREY: "leadsGrey",
  ANALYTICS_GREY: "analyticsGrey",
  ADD_LIST_GREY: "addListGrey",
  REMOVE_LIST_GREY: "removeListGrey",
  DROPDOWN_GREY: "dropdownGrey",
  LOCK_GREY: "lockGrey",
  LOCK_SELECTED: "lockSelected",
  LOCK_UNSELECTED: "lockUnselected",
  CONTACTS_GREY: "contactsGrey",
  CONTACTS_LEADS_GREY: "neutral.action.contactsLeadsGrey",
  VALIDATION_GREEN_TICK: "neutral.action.validationGreenTick",
  VALIDATION_STEP_ERROR: "neutral.action.validationStepError",
  VALIDATION_WARNING: "validationWarning",
  COMPANIES_GREY: "companiesGrey",
  AI_SDR_GREY: "aiSDRGrey",
  EXPORT_GREY: "exportGrey",
  BOTTOM_ARROW_BLACK: "bottomArrowBlack",
  RIGHT_ARROW_SMALL_GREY: "rightArrowSmallGrey",
  SIGNATURE_GREY: "signatureGrey",
  ADD_ROUNDED_GREY: "addRoundedGrey",
  LINK_GREY: "linkGrey",
  SEND_BLACK_FILLED: "sendBlackFilled",
  SUPER_AGI_NAME_LOGO: "superAgiNameLogo",
  SUPER_AGI_NAME_FULL_LOGO: "superAgiNameFullLogo",
  ON_CALL: "onCall",
  CALL_BLACK: "callBlack",
  VIA_GREY: "viaGrey",
  STAR_GREY: "starGrey",
  STAR_FILLED_GREY: "starFilledGrey",
  AT_THE_RATE_GREY: "atTheRateGrey",
  AT_THE_RATE_SELECTED: "atTheRateSelected",
  BLOCK_LISTS_UNSELECTED: "blockListsUnselected",
  BLOCK_LISTS_SELECTED: "blockListsSelected",
  ENCRYPTION_GREY: "encryptionGrey",
  RENAME: "rename",
  PROSPECTING_LINKEDIN_GREY: "prospectingLinkedinGrey",
  LINKEDIN: "linkedin",
  AUTOMATIC_EMAIL_GREY: "automaticEmailGrey",
  AUTOMATIC_EMAIL_WRAPPED: "automaticEmailWrapped",
  EMAIL_WRAPPED: "emailWrapped",
  CALL_WRAPPED: "callWrapped",
  LINKEDIN_WRAPPED: "linkedinWrapped",
  REMOVE_NOTE_GREY: "removeNoteGrey",
  SELECT_MANUAL_GREY: "selectManualGrey",
  ORDERED_LIST_GREY: "orderedListGrey",
  PROSPECTING_BROWSER_GREY: "prospectingBrowserGrey",
  CRM_SYNC_GREY: "crmSyncGrey",
  EXPAND_GREY: "expandGrey",
  ADD_TO_SEQUENCE_GREY: "addToSequenceGrey",
  CODE_GREY: "codeGrey",
  EXPORT_SELECTED: "exportSelected",
  EXPORT_UNSELECTED: "exportUnselected",
  CLICKED_ACTIVE: "clickedActive",
  CLICKED_INACTIVE: "clickedInactive",
  DELIVERED_ACTIVE: "deliveredActive",
  DELIVERED_INACTIVE: "deliveredInactive",
  REPLIED_ACTIVE: "repliedActive",
  REPLIED_INACTIVE: "repliedInactive",
  SEEN_ACTIVE: "seenActive",
  SEEN_INACTIVE: "seenInactive",
  SENT_ACTIVE: "sentIconActive",
  SENT_INACTIVE: "sentIconInactive",
  ACCEPTED_ACTIVE: "acceptedIconActive",
  ACCEPTED_INACTIVE: "acceptedIconInactive",
  DISCONNECT_GREY: "disconnectGrey",
  USER: "user",
  ROUND_ROBIN_GREY: "roundRobinGrey",
  AVAILABILITY_SELECTED: "availabilitySelected",
  AVAILABILITY_UNSELECTED: "availabilityUnselected",
  PROFILE_ICON_PLACEHOLDER: "profileIconPlaceholder",
  GOOGLE_MEET: "googleMeet",
  SUPER_MEET: "superMeet",
  MS_TEAMS: "msTeams",
  CALENDAR_GREY: "calendarGrey",
  GOOGLE_CALENDAR: "googleCalendar",
  OUTLOOK_CALENDAR: "outlookCalendar",
  INVERSE_GREY: "inverseGrey",
  BROWSER: "browser",
  COPY_UNSELECTED: "copyUnselected",
  ASSIGN_OWNER_GREY: "assignOwnerGrey",
  ACTIVE_DOT: "activeDot",
  INACTIVE_DOT: "inactiveDot",
  LOAD_BALANCING_GREY: "loadBalancingGrey",
  CALENDAR_TICK_GREY: "calendarTickGrey",
  MINUS: "minus",
  OBJECT_SELECTED: "objectSelected",
  OBJECT_UNSELECTED: "objectUnselected",
  ENCLOSED_CROSS_GREY: "enclosedCrossGrey",
  CROSS_GREY: "crossGrey",
  BANNER_CROSS: "bannerCross",
  SKIP: "skip",
  CHECK_ROUNDED_BLACK: "checkRoundedBlack",
  CHECK_ROUNDED_WHITE: "checkRoundedWhite",
  CHECK_ROUNDED_WHITE_EMPTY: "checkRoundedWhiteEmpty",
  CLOSE_WHITE: "closeWhite",
  CLOSE_VARIANT1: "closeVariant1",
  BACK_TO_TASKS: "backToTasks",
  MORE_HORIZONTAL: "moreHorizontal",
  UP_ARROW: "upArrow",
  DOWN_ARROW_WHITE: "downArrowWhite",
  PREVIEW_EYE_GREY: "previewEyeGrey",
  EMPTY_QUESTION_GREY: "emptyQuestionGrey",
  BLACK_PLUS: "blackPlus",
  EMBED_ELEMENT: "embedElement",
  EMBED_INLINE: "embedInline",
  INSERT_GREY: "insertGrey",
  EMPTY_SIGNALS_GREY: "emptySignalsGrey",
  SIGNALS_LOW: "signalsLow",
  SIGNALS_HIGH: "signalsHigh",
  SIGNALS_MEDIUM: "signalsMedium",
  VIEW_DETAILS: "viewDetails",
  VIEW_DETAILS_EXPAND_GREY: "viewDetailsExpandGrey",
  ACCESS_FOLDER_GREY: "accessFolderGrey",
  ATTACH_FILE_WHITE: "attachFileWhite",
  UPLOAD_1_GREY: "upload1Grey",
  BOLD_WHITE: "boldWhite",
  ITALIC_WHITE: "italicWhite",
  UNDERLINE_WHITE: "underlineWhite",
  LINK_WHITE: "linkWhite",
  QUOTE_WHITE: "quoteWhite",
  NUMBERED_LIST_WHITE: "numberedListWhite",
  LIST_WHITE: "listWhite",
  LEFT_ALIGN_WHITE: "leftAlignWhite",
  RIGHT_ALIGN_WHITE: "rightAlignWhite",
  JUSTIFY_WHITE: "justifyWhite",
  ALIGN_CENTER_WHITE: "alignCenterWhite",
  LEFT_ALIGN: "leftAlign",
  IMAGE_WHITE: "imageWhite",
  CLEAR_FORMATTING_WHITE: "clearFormattingWhite",
  LIGHTNING: "lightning",
  AGI_ASSISTANT_LIGHTNING: "agiAssistantLightning",
  BOOKMARK_GREY: "bookmarkGrey",
  BILLING_GREY: "billingGrey",
  OPEN_IN_NEW_TAB_GREY: "openInNewTabGrey",
  FORM: "form",
  REVOKE_GREY: "revokeGrey",
  SWITCH_GREY: "switchGrey",
  NOT_ALLOWED_GREY: "notAllowedGrey",
  UPLOAD_CSV_GREY: "uploadCsvGrey",
  CHECK_LIST_GREY: "checkListGrey",
  MARKET_RESEARCH_GREY: "marketResearchGrey",
  VOICE_AGENT_GREY: "voiceAgentGrey",
  QUALIFICATION_GREY: "qualificationGrey",
  MULTI_THREADING_GREY: "multiThreadingGrey",
  NEXT_BEST_ACTION_GREY: "nextBestActionGrey",
  END_WHITE: "endWhite",
  DOCUMENT_GREY: "documentGrey",
  IMAGE_GREY: "imageGrey",
  VIDEO_GREY: "videoGrey",
  CAMERA_GREY: "cameraGrey",
  SEND_GREY: "sendGrey",
  NOTE_GREY: "noteGrey",
  GO_TO_LINK_WHITE: "goToLinkWhite",
  APP_COLLECTION: "appCollection",
  ADD_STEP_GREY: "addStepGrey",
  BACKSPACE_GREY: "backspaceGrey",
  CANCEL_GREY: "cancelGrey",
  EXISTING_LEAD_GREY: "existingLeadGrey",
  EXISTING_CONTACT_GREY: "existingContactGrey",
  SUPER_SALES_APP_LOGO: "superSalesAppLogo",
  APP_QR: "appQr",
  DOWNLOAD_FROM_GOOGLE_PLAY: "downloadFromGooglePlay",
  DOWNLOAD_FROM_APP_STORE: "downloadFromAppStore",
  SETUP_FORM: "setupForm",
  DEFINE_ROUTING: "defineRouting",
  RESPONSE_LOGS: "responseLogs",
  CLOSE_GREY_FILLED: "closeGreyFilled",
  PROMPT: "prompt",
  ROUNDED_QUESTION_MARK: "roundedQuestionMark",
  ADD_TASK_GREY: "addTaskGrey",
  API_KEYS_SELECTED: "apiKeysSelected",
  API_KEYS_UNSELECTED: "apiKeysUnselected",
  CUSTOM_EVENTS_SELECTED: "customEventsSelected",
  CUSTOM_EVENTS_UNSELECTED: "customEventsUnselected",
  WHITE_ENRICH_SEARCH: "whiteEnrichSearch",
  LEAD_TAG_GREY: "leadTag",
  ASSISTANT_SELECTED: "agiChatsSelected",
  ASSISTANT_UNSELECTED: "agiChatsUnselected",
  GET_STARTED_SELECTED: "getStartedSelected",
  HOME_SELECTED: "homeSelected",
  HOME_UNSELECTED: "homeUnselected",
  PROSPECT_SELECTED: "prospectSelected",
  PROSPECT_UNSELECTED: "prospectUnselected",
  ENGAGE_SELECTED: "engageSelected",
  ENGAGE_UNSELECTED: "engageUnselected",
  SEQUENCES_SELECTED: "sequencesSelected",
  SEQUENCES_UNSELECTED: "sequencesUnselected",
  CALL_SELECTED: "callSelected",
  CALL_UNSELECTED: "callUnselected",
  VOICE_AGENT_ICON: "voiceAgentIcon",
  VOICE_AGENT_SELECTED: "voiceAgentIcon",
  VOICE_AGENT_UNSELECTED: "voiceAgentIcon",
  BUSINESS_RECEPTIONIST_SELECTED: "businessReceptionistSelected",
  BUSINESS_RECEPTIONIST_UNSELECTED: "businessReceptionistUnselected",
  BUILD_FROM_SCRATCH_ICON: "buildFromScratchIcon",
  DIALER_PHONE_ICON: "dialerPhoneIcon",
  CONVERSATIONS_SELECTED: "conversationsSelected",
  CRM_SELECTED: "crmSelected",
  CRM_UNSELECTED: "crmUnselected",
  CONTACTS_SELECTED: "contactsSelected",
  CONTACTS_UNSELECTED: "contactsUnselected",
  COMPANIES_SELECTED: "companiesSelected",
  COMPANIES_UNSELECTED: "companiesUnselected",
  LEADS_SELECTED: "leadsSelected",
  LEADS_UNSELECTED: "leadsUnselected",
  DEALS_SELECTED: "dealsSelected",
  DEALS_UNSELECTED: "dealsUnselected",
  LISTS_SELECTED: "listsSelected",
  LISTS_UNSELECTED: "listsUnselected",
  ANALYSE_SELECTED: "analyseSelected",
  ANALYSE_UNSELECTED: "analyseUnselected",
  AUTOMATE_SELECTED: "automateSelected",
  AUTOMATE_UNSELECTED: "automateUnselected",
  NEW_TASKS_UNSELECTED: "newTasksUnselected",
  ACTIONS_UNSELECTED: "actionsUnselected",
  SIDEBAR_CONTENT_SELECTED: "sidebarContentSelected",
  DATA_ENRICHMENT_SELECTED: "dataEnrichmentSelected",
  DATA_ENRICHMENT_UNSELECTED: "dataEnrichmentUnselected",
  SIGNALS_SELECTED: "signalsSelected",
  SIGNALS_UNSELECTED: "signalsUnselected",
  REPORTS_SELECTED: "reportsSelected",
  REPORTS_UNSELECTED: "reportsUnselected",
  EMAIL_SELECTED: "emailSelected",
  EMAIL_UNSELECTED: "emailUnselected",
  CONVERSATIONAL_INTELLIGENCE_SELECTED: "conversationalIntelligenceSelected",
  CONVERSATIONAL_INTELLIGENCE_UNSELECTED:
    "conversationalIntelligenceUnselected",
  AGENT_BUILDER_SELECTED: "agentBuilderSelected",
  AGENT_BUILDER_UNSELECTED: "agentBuilderUnselected",
  MEETINGS_SELECTED: "meetingsSelected",
  MEETINGS_UNSELECTED: "meetingsUnselected",
  LIBRARY_SELECTED: "librarySelected",
  LIBRARY_UNSELECTED: "libraryUnselected",
  PROCESS_DESIGN_SELECTED: "processDesignSelected",
  PROCESS_DESIGN_UNSELECTED: "processDesignUnselected",
  ESIGN_SELECTED: "esignSelected",
  ESIGN_UNSELECTED: "esignUnselected",
  REFER: "refer",
  ADD_MEMBER: "addMember",
  INSTALL_MOBILE: "installMobile",
  BUSY_CALL: "busyCall",
  GOING_CALL: "goingCall",
  FORWARD_CALL: "forwardCall",
  VOICEMAIL_CALL: "voicemailCall",
  TRANSFER_CALL: "transferCall",
  CANCELLED_CALL: "cancelledCall",
  POWER_DIALER_GREY: "powerDialerGrey",
  PARALLEL_DIALER_GREY: "parallelDialerGrey",
  DIALER_SELECTED: "dialerSelected",
  DIALER_UNSELECTED: "dialerUnselected",
  BUSINESS_PHONE_SELECTED: "businessPhoneSelected",
  BUSINESS_PHONE_UNSELECTED: "businessPhoneUnselected",
  SALES_DIALER_SELECTED: "salesDialerSelected",
  SALES_DIALER_UNSELECTED: "salesDialerUnselected",
  DIALER_NOTE_SELECTED: "dialerNoteSelected",
  DIALER_NOTE_UNSELECTED: "dialerNoteUnselected",
  MUTE_SELECTED: "muteSelected",
  MUTE_UNSELECTED: "muteUnselected",
  RECORD_SELECTED: "recordSelected",
  RECORD_UNSELECTED: "recordUnselected",
  TRANSFER_SELECTED: "transferSelected",
  TRANSFER_UNSELECTED: "transferUnselected",
  CALL_SWAP: "callSwap",
  PHONE_NUMBERS_SELECTED: "phoneNumbersSelected",
  PHONE_NUMBERS_UNSELECTED: "phoneNumbersUnselected",
  DIALER_SETTINGS_SELECTED: "dialerSettingsSelected",
  DIALER_SETTINGS_UNSELECTED: "dialerSettingsUnselected",
  CALL_ROUTING_SELECTED: "callRoutingSelected",
  CALL_ROUTING_UNSELECTED: "callRoutingUnselected",
  CALL_DISPOSITION_SELECTED: "callDispositionSelected",
  CALL_DISPOSITION_UNSELECTED: "callDispositionUnselected",
  RECORD_ICON: "recordIcon",
  RECORDING_ICON: "recordingIcon",
  STOP_RECORDING_GREY: "stopRecordingGrey",
  TRANSCRIPT_GREY: "transcriptGrey",
  IN_PROGRESS_GREEN_TAG: "inProgressGreenTag",
  IN_PROGRESS_PURPLE_TAG: "inProgressPurpleTag",
  VOICE_AGENT_PLAY: "voiceAgentPlay",
  DIAL_ICON: "dialIcon",
  DIALPAD_ICON: "dialpadIcon",
  INBOUND_AGENT_SELECTED: "inboundAgentSelected",
  INBOUND_AGENT_UNSELECTED: "inboundAgentUnselected",
  PROJECTS_SELECTED: "projectsSelected",
  PROJECTS_UNSELECTED: "projectUnselected",
  DASHBOARDS_SELECTED: "dashboardsSelected",
  DASHBOARDS_UNSELECTED: "dashboardsUnselected",
  INBOX_SELECTED: "inboxSelected",
  INBOX_UNSELECTED: "inboxUnselected",
  AGENT_INSTRUCTIONS_SELECTED: "agentInstructionsSelected",
  AGENT_INSTRUCTIONS_UNSELECTED: "agentInstructionsUnselected",
  KNOWLEDGE_BASE_SELECTED: "knowledgeBaseSelected",
  KNOWLEDGE_BASE_UNSELECTED: "knowledgeBaseUnselected",
  LIVE_CHAT_WIDGET_SELECTED: "liveChatWidgetSelected",
  LIVE_CHAT_WIDGET_UNSELECTED: "liveChatWidgetUnselected",
  AUTO_THEME_GREY: "autoThemeGrey",
  DARK_THEME_GREY: "darkThemeGrey",
  LIGHT_THEME_GREY: "lightThemeGrey",
  FLAG_US: "flagUS",
  FLAG_UK: "flagUK",
  FLAG_NZ: "flagNZ",
  FLAG_CH: "flagCH",
  FLAG_IN: "flagIN",
  FLAG_AU: "flagAU",
  FLAG_SG: "flagSG",
  FLAG_CA: "flagCA",
  FLAG_ES: "flagES",
  FLAG_DE: "flagDE",
  FLAG_FR: "flagFR",
  FLAG_JP: "flagJP",
  FLAG_PT: "flagPT",
  FLAG_BR: "flagBR",
  FLAG_IE: "flagIE",
  FLAG_MY: "flagMY",
  FLAG_MULTILINGUAL: "flagMultilingual",
  WHAT_TO_TALK: "whatToTalk",
  CHART_LOADER: "chartLoader",
  TABLE_LOADER: "tableLoader",
  MORE_DOTS: "moreDots",
  OUTLINED_QUESTION_MARK: "outlinedQuestionMark",
  ZOOM_ICON: "zoomIcon",
  DOMAIN_SELECTED: "domainSelected",
  DOMAIN_UNSELECTED: "domainUnselected",
  PROSPECT_SEARCH_ICON: "prospectSearchIcon",
  TICK_ICON: "tickIcon",
  SYNC_ICON_GREY: "syncIconGrey",
  BUSINESS_NAME_ICON: "businessNameIcon",
  RETRY_ICON_GREY: "retryIconGrey",
  MEETINGS_TALKTIME_SELECTED: "meetingsTalkTimeSelected",
  MEETINGS_TALKTIME_UNSELECTED: "meetingsTalkTimeUnselected",
  MEETINGS_TRANSCRIPT_SELECTED: "meetingsTranscriptSelected",
  MEETINGS_TRANSCRIPT_UNSELECTED: "meetingsTranscriptUnselected",
  MEETINGS_INTELLIGENCE_SELECTED: "meetingsIntelligenceSelected",
  MEETINGS_INTELLIGENCE_UNSELECTED: "meetingsIntelligenceUnselected",
  PROSPECT_EMPTY_SCREEN: "prospectEmptyScreen",
  RECOMMENDED_PROSPECTS: "recommendedProspects",
  TO_LEFT_ARROW: "toLeftArrow",
  EXPORT_MAILBOX_ICON: "exportMailboxIcon",
  SUPER_AGI_ACADEMY_ICON: "superAGIAcademyIcon",
  CUSTOMERS_SELECTED: "customersSelected",
  CUSTOMERS_UNSELECTED: "customersUnselected",
  REDIRECT_GRADIENT: "redirectGradient",
  PLAY_VARIANT1_ICON: "playVariant1Icon",
  PLAY_VARIANT2_ICON: "playVariant2Icon",
  EMAIL_VERIFIED_ICON: "emailVerifiedIcon",
  EMAIL_UNVERIFIED_ICON: "emailUnverifiedIcon",
  EMAIL_ACTION: "emailAction",
  ENCRYPTED_SELECTED: "encryptedSelected",
  ENCRYPTED_UNSELECTED: "encryptedUnselected",
  CONTENT_PASTE_SEARCH: "contentPasteSearch",
  CHECK_CIRCLE: "checkCircle",
  CHECK_CIRCLE_2: "checkCircle2",
  BLOCK_RED: "blockRed",
  REMOVED_USER: "removedUser",
  RED_INFO: "redInfo",
  YELLOW_WARNING: "yellowWarning",
  WARNING_ICON: "warningIcon",
  HTML_CODE: "htmlCode",
  TEXT_EDITOR: "textEditor",
  TEXT_EDITOR_GREY: "textEditorGrey",
  HTML_CODE_GREY: "htmlCodeGrey",
  X_GRADIENT: "xIconGradient",
  LINKEDIN_GRADIENT: "linkedinIconGradient",
  WHATSAPP_GRADIENT: "whatsappIconGradient",
  FACEBOOK_GRADIENT: "facebookIconGradient",
  EMAIL_GRADIENT: "emailIconGradient",
  CAMPAIGN_ICON: "campaignsIcon",
  MOBILE_ICON: "mobileIcon",
  DESKTOP_ICON: "desktopIcon",
  LINK_ICON_WHITE: "linkIconWhite",
  LINK_ICON_GREY: "linkIconGrey",
  RECIPIENTS_ICON_WHITE: "recipientsIconWhite",
  RECIPIENTS_ICON_GREY: "recipientsIconGrey",
  EMAIL_CAMPAIGN_ICON_WHITE: "emailCampaignWhiteIcon",
  EMAIL_CAMPAIGN_SETTINGS_UNSELECTED: "emailCampaignSettingsUnselectedIcon",
  EMAIL_CAMPAIGN_SETTINGS_SELECTED: "emailCampaignSettingsSelectedIcon",
  MARKETING_SELECTED: "marketingSelected",
  MARKETING_UNSELECTED: "marketingUnselected",
  ECOMMERCE_MARKETING_SELECTED: "ecommerceMarketingSelected",
  ECOMMERCE_MARKETING_UNSELECTED: "ecommerceMarketingUnselected",
  CAMPAIGNS_SELECTED: "campaignsSelected",
  CAMPAIGNS_UNSELECTED: "campaignsUnselected",
  ONBOARDING_IMAGE: "onboardingImage",
  PLUS_GREY: "plusGrey",
  ASSOCIATIONS: "associations",
  ASSOCIATIONS_GREY: "associationsGrey",
  PROPERTIES: "properties",
  PROPERTIES_GREY: "propertiesGrey",
  PROPERTY_TYPE_TEXT: "propertyTypeText",
  PROPERTY_TYPE_NUMBER: "propertyTypeNumber",
  PROPERTY_TYPE_SELECT: "propertyTypeSelect",
  PROPERTY_TYPE_MULTI_SELECT: "propertyTypeMultiSelect",
  PROPERTY_TYPE_DATE: "propertyTypeDate",
  PROPERTY_TYPE_DATETIME: "propertyTypeDatetime",
  PROPERTY_TYPE_URL: "propertyTypeUrl",
  PROPERTY_TYPE_EMAIL: "propertyTypeEmail",
  PROPERTY_TYPE_PHONE: "propertyTypePhone",
  PROPERTY_TYPE_USER: "propertyTypeUser",
  PROPERTY_TYPE_BOOLEAN: "propertyTypeBoolean",
  OPEN_IN_FULL_MODE: "openInFullMode",
  OPEN_CHAT_SELECTED_ICON: "openChatSelectedIcon",
  OPEN_CHAT_UNSELECTED_ICON: "openChatUnselectedIcon",
  CLOSE_CHAT_SELECTED_ICON: "closeChatSelectedIcon",
  CLOSE_CHAT_UNSELECTED_ICON: "closeChatUnselectedIcon",
  SORT_ASCENDING_NEUTRAL: "sortAscendingNeutral",
  SORT_DESCENDING_NEUTRAL: "sortDescendingNeutral",
  MANAGE_COLUMNS: "manageColumns",
  EYE_OFF_GREY: "eyeOffGrey",
  PLUS_GREY_THIN: "plusGreyThin",
  EYE_GREY: "eyeGrey",
  ADD_MEMBER_OPTION: "addMemberOption",
  REPLIED_ICON: "repliedIcon",
  DOMAIN_GREY: "domainGrey",
  MICROPHONE: "microphone",
  VOICE_AI_MIC: "voiceAiMic",
  PIN: "pin",
  UNPIN: "unpin",
  PANEL_PROJECT: "panelProject",
  PANEL_ANALYTICS: "panelAnalytics",
  PANEL_PROPERTY: "panelProperty",
  PANEL_NOTES: "panelNotes",
  PANEL_REPOSITORY: "panelRepository",
  PROJECT_GREY: "projectGrey",
  MORE_ICON_GREY: "moreIconGrey",
  EDIT_V2: "editV2",
  ARROW_OUTWARD: "arrowOutward",
  WEBSITE_UNPUBLISH: "websiteUnpublish",
  BOLT_ICON: "bolt",
  TABLE_GREY: "tableGrey",
  BOARD_GREY: "boardGrey",
  PROPERTY_VISIBILITY_GREY: "propertyVisibilityGrey",
  DASHBOARD_GREY: "dashboardGrey",
  CARDS_GREY: "cardsGrey",
  CUSTOMER_SUCCESS_SELECTED: "customerSuccessSelected",
  CUSTOMER_SUCCESS_UNSELECTED: "customerSuccessUnselected",
  SUPER_AGI_FILLED_BOLT: "superAGIFilledBolt",
  SUPER_AGI_HOLLOW_BOLT: "superAGIHollowBolt",
  HIERARCHY: "hierarchy",
  HIERARCHY_GREY: "hierarchyGrey",
  PARENT_OBJECT_GREY: "parentObjectGrey",
  CHILD_OBJECT_GREY: "childObjectGrey",
  VIEW_AGENDA: "viewAgendaIcon",
  SINGLE_COLUMN: "singleColumnIcon",
  DOUBLE_COLUMN: "doubleColumnIcon",
  AI_CARD_ICON: "aiCardIcon",
  TABLE_CARD_ICON: "tableCardIcon",
  NUMBER_CARD_ICON: "numberCardIcon",
  GRAPH_CARD_ICON: "graphCardIcon",
  REORDER_ICON: "reorderIcon",
  SQL_ANALYTICS: "sqlAnalytics",
  MANUAL_ANALYTICS: "manageAnalytics",
  AREA_CHART: "areaChart",
  DONUT_CHART: "donutChart",
  GAUGE_CHART: "gaugeChart",
  HORIZONTAL_CHART: "horizontalChart",
  KPI_CHART: "kpiChart",
  LINE_CHART: "lineChart",
  PIE_CHART: "pieChart",
  SCATTER_CHART: "scatterChart",
  TABLE_CHART: "tableChart",
  VERTICAL_CHART: "verticalChart",
  PIVOT_TABLE: "pivotTable",
  SHARE: "share",
  PERCENTAGE_GREY: "percentageGrey",
  FUNNEL_CHART: "funnelChart",
  ADD_PURPLE: "addPurple",
  RESIZE: "resize",
  MSG_91_ICON: "msg91Icon",
  CUSTOMER_SUCCESS_SETTINGS_SELECTED: "customerSuccessSettingsSelected",
  CUSTOMER_SUCCESS_SETTINGS_UNSELECTED: "customerSuccessSettingsUnselected",
  EMPTY_CHART_PLACEHOLDER: "emptyChartPlaceholder",
  CALCULATE_GREY: "calculateGrey",
  CONVERSION_RATE: "conversionRate",
  COMPARE_ARROWS: "compareArrows",
  FORMS_SELECTED: "formsSelected",
  FORMS_UNSELECTED: "formsUnselected",
  AI_QA_SELECTED: "aiQaSelected",
  AI_QA_UNSELECTED: "aiQaUnselected",
  CHECK_CIRCLE_OUTLINED: "checkCircleOutlined",
  CLOCK_GREY: "clockGrey",
  MOVE: "move",
  UNIBOX_SETTINGS_SELECTED: "uniboxSettingsSelected",
  UNIBOX_SETTINGS_UNSELECTED: "uniboxSettingsUnselected",
  UNIBOX_SELECTED: "uniboxSelected",
  UNIBOX_UNSELECTED: "uniboxUnselected",
  ATS_SELECTED: "atsSelected",
  ATS_UNSELECTED: "atsUnselected",
  PEOPLE_SELECTED: "peopleSelected",
  PEOPLE_UNSELECTED: "peopleUnselected",
  PERFORM_SELECTED: "performSelected",
  PERFORM_UNSELECTED: "performUnselected",
  TIME_OFF_SELECTED: "timeOffSelected",
  TIME_OFF_UNSELECTED: "timeOffUnselected",
  ATTENDANCE_SELECTED: "attendanceSelected",
  ATTENDANCE_UNSELECTED: "attendanceUnselected",
  APPROVALS_SELECTED: "approvalsSelected",
  APPROVALS_UNSELECTED: "approvalsUnselected",
  HR_SELECTED: "hrSelected",
  HR_UNSELECTED: "hrUnselected",
  MESSAGE: "messageIcon",
  MEETING_LINKS_SELECTED: "meetingLinksSelected",
  MEETING_LINKS_UNSELECTED: "meetingLinksUnselected",
  MEETING_NOTETAKER_SELECTED: "meetingNotetakerSelected",
  MEETING_NOTETAKER_UNSELECTED: "meetingNotetakerUnselected",
  MEETING_ROUTER_SELECTED: "meetingRouterSelected",
  MEETING_ROUTER_UNSELECTED: "meetingRouterUnselected",
  CODER_SELECTED: "coderSelected",
  CODER_UNSELECTED: "coderUnselected",
  MOBILE_APP_SELECTED: "mobileAppSelected",
  MOBILE_APP_UNSELECTED: "mobileAppUnselected",
  LANDING_PAGE_SELECTED: "landingPageSelected",
  LANDING_PAGE_UNSELECTED: "landingPageUnselected",
  GAME_2D_SELECTED: "game2dSelected",
  GAME_2D_UNSELECTED: "game2dUnselected",
  GAME_3D_SELECTED: "game3dSelected",
  GAME_3D_UNSELECTED: "game3dUnselected",
  VIBE_VIDEO_SELECTED: "vibeVideoSelected",
  VIBE_VIDEO_UNSELECTED: "vibeVideoUnselected",
  DEVELOPER_CENTER_SELECTED: "developerCenterSelected",
  DEVELOPER_CENTER_UNSELECTED: "developerCenterUnselected",
  DEVELOPER_TOOLS_SELECTED: "developerToolsSelected",
  DEVELOPER_TOOLS_UNSELECTED: "developerToolsUnselected",
  SANDBOX_SELECTED: "sandboxSelected",
  SANDBOX_UNSELECTED: "sandboxUnselected",
  PERSONAL_TOKENS_SELECTED: "personalTokensSelected",
  PERSONAL_TOKENS_UNSELECTED: "personalTokensUnselected",
  SSH_KEYS_SELECTED: "sshKeysSelected",
  SSH_KEYS_UNSELECTED: "sshKeysUnselected",
  REPO_SETTINGS_SELECTED: "repoSettingsSelected",
  REPO_SETTINGS_UNSELECTED: "repoSettingsUnselected",
  REPO_BRANCHES_SELECTED: "repoBranchesSelected",
  REPO_BRANCHES_UNSELECTED: "repoBranchesUnselected",
  REPO_WEBHOOKS_SELECTED: "repoWebhooksSelected",
  REPO_WEBHOOKS_UNSELECTED: "repoWebhooksUnselected",
  REPO_RULESETS_SELECTED: "repoRulesetsSelected",
  REPO_RULESETS_UNSELECTED: "repoRulesetsUnselected",
  MERGE_PR: "mergePR",
  CLOSE_PR: "closePR",
  DRAFT: "draft",
  RELOAD: "reload",
  REVERT: "revert",
  DIGITAL_EMPLOYEES_SELECTED: "digitalEmployeesSelected",
  DIGITAL_EMPLOYEES_UNSELECTED: "digitalEmployeesUnselected",
  INFERENCE_ROUTER_SELECTED: "inferenceRouterSelected",
  INFERENCE_ROUTER_UNSELECTED: "inferenceRouterUnselected",
  LIVE_ASSIST_SELECTED: "liveAssistSelected",
  LIVE_ASSIST_UNSELECTED: "liveAssistUnselected",
  APPLE_ICON: "appleIcon",
  GITHUB_ICON: "githubIcon",
  GITHUB_ICON_WHITE: "githubIconWhite",
  GITHUB_ICON_INVERTED: "githubIconInverted",
  CODE_REVIEWER_SELECTED: "codeReviewerSelected",
  CODE_REVIEWER_UNSELECTED: "codeReviewerUnselected",
  ERROR_LOGGING_SELECTED: "errorLoggingSelected",
  ERROR_LOGGING_UNSELECTED: "errorLoggingUnselected",
  EXPAND_ICON: "expandHuddle",
  COLLAPSE_ICON: "collapseHuddle",
  MUTE_ICON: "muteHuddle",
  VIDEO_ICON: "videoHuddle",
  SCREEN_SHARE_ICON: "screenShareHuddle",
  MUTED_ICON: "mutedHuddle",
  RESIZE_GRIP: "resizeGrip",
  SIGNAL_WAVE: "signalWave",
  FORWARD_GREY: "forwardGrey",
  GROUP: "group",
  NEW_CHAT: "newChat",
  WORKSPACE_SPECIAL_CHAR_ICON: "workspaceSpecialCharIcon",
  NULL_ENTITY_PLACEHOLDER: "nullEntityPlaceholder",
  CODE: "code",
  COMMITS: "commits",
  PULL_REQUESTS: "pull_requests",
  FORK_REPO: "fork_repo",
  BRANCH_REPO: "branch_repo",
  GIT_ACTIONS: "git_actions",
  CHAT_ACTION: "chat_action",
};
